import ApiClient from '../../../services/apiClient';
import { useMutation } from 'react-query';

const _apiClient = new ApiClient();

export const useUserAcknowledgeAnnouncement = (onError?: (errorMessage: string) => void) => {
    return useMutation({
        mutationFn: async (announcementContentGuid: string) => {
            const response = await  _apiClient.acknowledgeAnnouncement(announcementContentGuid);

            if (!response?.httpResponse.ok) {
                if (response.errorMessage && response.httpResponse.status == 400) {
                    if (response.errors !== undefined && response.errors[0] !== undefined) {
                        throw new Error(
                            `Failed to acknowledge announcement : ${response.errors[0].message}`
                        );
                    }
                }
                throw new Error('Failed to acknowledge announcement');
            }
            return response.payload;
        },
        onError(error) {
            if (error instanceof Error && typeof onError === 'function') {
                onError(error.message);
            }
        },
    });
}
    